export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4695.ae2b774d.jpg";